import { render, staticRenderFns } from "./IconPreview.vue?vue&type=template&id=28e7447c&"
import script from "./IconPreview.vue?vue&type=script&lang=js&"
export * from "./IconPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports